import { inject, Injectable } from '@angular/core';
import { AuthConfig } from '@auth0/auth0-angular';
import { EnvironmentInstanceToken } from '../interfaces/environment.interface';
import { MsalAuthEnvironmentConfig } from '../interfaces/msal-auth-config.interface';

@Injectable({
    providedIn: 'root',
})
export class EnvironmentService {
    private readonly environment = inject(EnvironmentInstanceToken);

    public constructor() {
        const el = document.querySelector<HTMLMetaElement>(`meta[name="apiBase"]`);
        if (el?.content.startsWith('http')) {
            this.environment.apiBase = el.content;
        }

        this.environment.apiBase = this.environment.apiBase?.replace(/[/\\]+$/, '');
        this.environment.apiSapProxy = this.environment.apiSapProxy?.replace(/^[/\\]+/, '');
        this.environment.complaintsLinkPath = this.environment.complaintsLinkPath?.replace(/^[/\\]+/, '');
    }

    public get appId(): string {
        return this.environment.appId;
    }

    public get production(): boolean {
        return this.environment.production;
    }

    public get operateInMockMode(): boolean {
        return this.environment.operateInMockMode;
    }

    public get apiBase(): string {
        return this.environment.apiBase;
    }

    public get apiSapProxy(): string {
        return this.environment.apiSapProxy;
    }

    public get reportIssueSupportEmail(): string {
        return this.environment.reportIssueSupportEmail;
    }

    public get bundleIdentifierName(): string {
        return this.environment.bundleIdentifierName;
    }

    public get subscriptionServerPublicKey(): string | undefined {
        return this.environment.subscriptionServerPublicKey;
    }

    public get appInsightsConnectionString(): string | undefined {
        return this.environment.appInsightsConnectionString;
    }

    public get msal(): MsalAuthEnvironmentConfig | undefined {
        return this.environment.msal;
    }

    public get auth0(): AuthConfig | undefined {
        return this.environment.auth0;
    }

    public get auth0Enabled(): boolean {
        return !!this.environment.auth0?.clientId;
    }

    public get msalEnabled(): boolean {
        return !!this.environment.msal?.clientId;
    }

    public get subscribeNotificationsUrl(): string {
        if (this.environment.subscribeNotificationsOverride) {
            return this.environment.subscribeNotificationsOverride;
        }
        return this.environment.apiBase;
    }

    public get complaintsLinkUrl(): string | undefined {
        if (this.environment.complaintsLinkPath) {
            return `${this.environment.apiBase}/${this.environment.complaintsLinkPath}`;
        }
        return undefined;
    }
}
